export enum PluginTypes {
  MEDDPICC = 'meddpicc-plugin',
  MEDDIC = 'meddic-plugin',
  BANT = 'bant-plugin',
  DATA_MANAGEMENT = 'data-management-plugin',
  DYNAMIC_PATH = 'dynamic-path-plugin',
}
